module.exports = __webpack_public_path__ + "static/media/sa.135d0c86.svg";